var map = {
	"./aswatson.png": "055f",
	"./aws.jpg": "e96c",
	"./belun-square.png": "2740",
	"./belun.png": "6a7a",
	"./cmhk.jpeg": "4f1b",
	"./cmhk.png": "9c09",
	"./fbstart.jpg": "e619",
	"./fiberapi.jpg": "68b0",
	"./fiberapi.png": "a8fc",
	"./googleeye.jpg": "4e89",
	"./hkqaa.jpg": "27a5",
	"./hkqaa.png": "009d",
	"./hkstp.jpg": "2ad6",
	"./hkstp.png": "d2f3",
	"./jebsen.png": "e3f3",
	"./jrg.png": "78e5",
	"./kong-color.svg": "19f3",
	"./kong.jpg": "55a9",
	"./kong.png": "a3a6",
	"./mf.jpg": "3cb9",
	"./onedegree.png": "9610",
	"./pearson.jpg": "6d5b",
	"./qfpay-logo.jpg": "b921",
	"./qfpay.jpg": "9a7f",
	"./qfpay.png": "0701",
	"./qfpay.svg": "b193",
	"./spread-it.png": "392d",
	"./sunstar.png": "82cf",
	"./taptab-logo.png": "d7d4",
	"./taptab.jpg": "da38",
	"./telkie.jpg": "8484",
	"./telkie.png": "72ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "78ea";